export default "__VITE_ASSET__7b15abe4__"